<template lang="pug">
    .button-input(:class="bClasses")
        v-text-field.binput(
            v-bind="iProps" 
            v-model="inputModel" 
            )
        v-btn.ibtn(
            v-bind="bProps"
            style="min-width:150px; width: 176px;"
            @click="$emit('button:click')"
            ) 
            span(v-if="buttonPosition === 'right'") {{buttonText}}
            v-icon(
                :right="buttonPosition === 'right'"
                :left="buttonPosition === 'left'"
                v-if="btnIcon") {{buttonIcon}}
            span(v-if="buttonPosition === 'left'") {{buttonText}}
            v-progress-circular.loader(
                :color="colors.primary"
                indeterminate
                v-if="loading"
                )
</template>

<script>
export default {
    name: 'input-button',
    props: {
        /**
         * @description
         */
        inputProps: {
            type: Object,
            default: () => {},
        },
        /**
         * @description
         */
        buttonProps: {
            type: Object,
            default: () => {},
        },
        /**
         * @description
         */
        btnText: {
            type: String,
            default: () => 'default-value',
        },
        /**
         * @description
         */
        btnIcon: {
            type: String,
            default: () => null,
        },
        /**
         * @description
         */
        buttonPosition: {
            type: String,
            default: () => 'left',
        },
        /**
         * @description
         */
        value: {
            default: () => '',
        },
        /**
         * @description
         */
        loading: {
            type: Boolean,
            default: () => false,
        },
    },
    data: function() {
        return {
            inputDefProps: {
                outline: true,
            },
            buttonDefProps: {
                color: 'primary',
                dark: true,
                large: true,
                depressed: true,
                width: '150px',
            },
            asdf: 'asdf',
            loadingInputProps: {
                disabled: true,
            },
            loadingButtonProps: {
                disabled: true,
            },
        }
    },
    computed: {
        iProps: function() {
            let obj = { ...this.inputProps }
            let def = { ...this.inputDefProps }
            Object.assign(def, obj)
            if (this.loading) Object.assign(def, this.loadingInputProps)
            return def
        },
        bProps: function() {
            let obj = { ...this.buttonProps }
            let def = { ...this.buttonDefProps }
            Object.assign(def, obj)
            def.class = this.bClasses
            if (this.loading) Object.assign(def, this.loadingButtonProps)
            return def
        },
        bClasses: function() {
            if (this.buttonPosition === 'right') return { right: true }
            return { left: true }
        },
        /**
         * @description
         */
        buttonText: function() {
            if (this.loading) return ''
            return this.btnText
        },
        /**
         * @description
         */
        buttonIcon: function() {
            if (this.loading) return ''
            return this.btnIcon
        },
        /**
         * @description
         */
        inputModel: {
            get: function() {
                return this.value
            },
            set: function(val) {
                this.$emit('input', val)
            },
        },
    },
    methods: {},
    watch: {},
    components: {},
    mixins: [],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    // mounted: function(){...},
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss" scoped>
.button-input {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    width: 100%;
    &.left {
        flex-direction: row-reverse;
    }
    .ibtn {
        height: 56px;
        margin: 0px;
        &.right {
            border-top-right-radius: 4px;
            border-bottom-right-radius: 4px;
            margin-left: -4px;
        }
        &.left {
            border-top-left-radius: 4px;
            border-bottom-left-radius: 4px;
            margin-right: -4px;
        }
    }
}
</style>